// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 0.5C13.1905 0.5 14.2406 1.09427 14.8724 2H21.5V22H2.5V2H9.12759C9.75936 1.09427 10.8095 0.5 12 0.5ZM13 13.5V7.5H11V13.5H13ZM13.0039 14.9961H11V17H13.0039V14.9961Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-assignment-error-filled')
export default class AssignmentErrorFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'assignment-error-filled',
    }
  }
}
